import styles from 'vet-bones/styles/colors.scss';

export const colors = {
  connected: styles['sd-cyan'],
  darkIcon: styles['sd-dark-gray-blue'],
  queryBuilderGrayId: 'sd-qb-gray',
};
